import Swiper, { Autoplay, Pagination } from 'swiper'

const bannerSlider = () => {
  const swiper = new Swiper('.swiper.banner__slider', {
    modules: [Pagination, Autoplay],

    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 1,
    breakpoints: {
      769: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.banner__pagination',
    },
  })
}

export default bannerSlider
